export const serviceObjA = {
    iconx: './pictures/ServiceName/ICON.svg',
    headline: 'Web Design',
    description: 'Increase the value of a product by enhancing your online visibility with a professionally designed website.',
    imgStart: '',
    img: './pictures/ServiceName/Service1.svg',
    alt: 'service'
}

export const serviceObjB = {
    iconx: './pictures/ServiceName/ICON.svg',
    headline: 'Mobile Design',
    description: 'Personalized design for your mobile applications that are made for your specific requirements to reach a larger audience.',
    imgStart: 'start',
    img: './pictures/ServiceName/Service2.svg',
    alt: 'service'
}

export const serviceObjC = {
    iconx: './pictures/ServiceName/ICON.svg',
    headline: 'Websites',
    description: 'Boost your brand by establishing a platform through with use of a well-designed websites that is suitable for the current world.',
    imgStart: '',
    img: './pictures/ServiceName/Service3.svg',
    alt: 'service'
}

export const serviceObjD = {
    iconx: './pictures/ServiceName/ICON.svg',
    headline: 'Logo Design',
    description: 'Bringing your brand online to connect with more users with the taste of modern and customize logo and layouts of your product.',
    imgStart: 'start',
    img: './pictures/ServiceName/Service4.svg',
    alt: 'service'
}